import React from 'react';
import styles from './RolloverConfirm.module.css';

const RolloverConfirm = ({ stepData }) => {
  const verification = stepData?.verification;
  const canRollover = stepData?.canRollover !== false;

  return (
    <div className={styles.container}>
      <div className={styles.confirmBox}>
        <h2 className={styles.title}>Date Rollover Verification</h2>
        <p className={styles.description}>
          {stepData?.message || 'Verify all items completed and roll over to next date.'}
        </p>

        {/* Verification Status */}
        {verification && (
          <div className={styles.verificationStatus}>
            <h3>Verification Status</h3>
            
            <div className={styles.verificationItems}>
              <div className={`${styles.statusItem} ${verification.pendingCheckouts === 0 ? styles.complete : styles.pending}`}>
                <span className={styles.icon}>
                  {verification.pendingCheckouts === 0 ? 'DONE' : 'WARN'}
                </span>
                <span className={styles.label}>
                  Checkouts: {verification.pendingCheckouts === 0 
                    ? 'Complete' 
                    : `${verification.pendingCheckouts} pending`}
                </span>
              </div>

              <div className={`${styles.statusItem} ${verification.pendingCheckins === 0 ? styles.complete : styles.pending}`}>
                <span className={styles.icon}>
                  {verification.pendingCheckins === 0 ? 'DONE' : 'WARN'}
                </span>
                <span className={styles.label}>
                  Check-ins: {verification.pendingCheckins === 0 
                    ? 'Complete' 
                    : `${verification.pendingCheckins} pending`}
                </span>
              </div>
            </div>

            {/* Show pending items if any */}
            {!verification.allClear && (
              <div className={styles.warningBox}>
                <h4>Cannot Complete Rollover</h4>
                <p>The following items must be completed first:</p>
                
                {verification.pendingCheckoutList && verification.pendingCheckoutList.length > 0 && (
                  <div className={styles.pendingList}>
                    <strong>Pending Checkouts:</strong>
                    <ul>
                      {verification.pendingCheckoutList.map((booking) => (
                        <li key={booking.id}>
                          Room {booking.roomNumber} - {booking.guestName}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {verification.pendingCheckinList && verification.pendingCheckinList.length > 0 && (
                  <div className={styles.pendingList}>
                    <strong>Pending Check-ins:</strong>
                    <ul>
                      {verification.pendingCheckinList.map((booking) => (
                        <li key={booking.id}>
                          Room {booking.roomNumber} - {booking.guestName}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Backlog Info */}
        {stepData?.hasBacklog && stepData?.backlogInfo && (
          <div className={styles.backlogInfo}>
            <p>
              After completing this date, you will move to the next missed date in the backlog.
            </p>
            <p>
              Remaining: {stepData.backlogInfo.totalMissed} date(s)
            </p>
          </div>
        )}

        {/* Next Date */}
        {stepData?.nextDate && (
          <div className={styles.nextDateInfo}>
            <p>Next Date: <strong>{stepData.nextDate}</strong></p>
          </div>
        )}

        {/* Note */}
        <div className={styles.note}>
          <strong>Note:</strong> {canRollover 
            ? 'After rollover, the system date will advance to the next business day. This action cannot be undone without admin intervention.'
            : 'Complete all pending items listed above before proceeding with rollover.'}
        </div>
      </div>
    </div>
  );
};

export default RolloverConfirm;
